import {SxProps} from '@mui/material';

export const STYLES = {
  divider: {
    m: '0 19px 0 16px',
    borderWidth: '1px',
  },
  tabPanel: {
    p: 0,
  },
} as const satisfies SxProps;
